import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_COMMUNICATION_MANAGER = createActionTypes('CREATE_COMMUNICATION_MANAGER');
export const FETCH_COMMUNICATION_MANAGER = createActionTypes('FETCH_COMMUNICATION_MANAGER');
export const GET_COMMUNICATION_MANAGER = createActionTypes('GET_COMMUNICATION_MANAGER');
export const UPDATE_COMMUNICATION_MANAGER = createActionTypes('UPDATE_COMMUNICATION_MANAGER');
export const DELETE_COMMUNICATION_MANAGER = createActionTypes('DELETE_COMMUNICATION_MANAGER');
